import { t } from '../i18n';

export const REACTION_EMOJIS = ['👍', '❤️', '😂', '➕', '🤔', '🎉', '👀', '🔥'] as const;

// Absolute datetime for hover-tooltips on relative-time labels — so reviewers
// can confirm an exact time without ambiguity.
export function formatAbsoluteTime(iso: string): string {
  return new Date(iso).toLocaleString('de-CH', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Builds the tooltip for a reaction chip: comma-separated names with the
// viewer surfaced as `Du` at the front, capped at 5 names then `und N weitere`.
export function formatReactorList(names: string[], mine: boolean, ownName: string): string {
  let list = names.slice();
  if (mine) {
    if (ownName) list = list.filter((n) => n !== ownName);
    list.unshift(t('format.reactor-you'));
  }
  if (list.length === 0) return '';
  const MAX = 5;
  if (list.length <= MAX) return list.join(', ');
  return list.slice(0, MAX).join(', ') + ' ' + t('format.reactor-more', { count: list.length - MAX });
}

export function truncate(s: string, n: number): string {
  return s.length <= n ? s : s.slice(0, n - 1) + '…';
}
